module.exports = __webpack_public_path__ + "static/02-3a6a7ff4bd0c210d91aaa34ccf78dbb9.jpg";